import { render, staticRenderFns } from "./FeaturedQuotesCarousel.vue?vue&type=template&id=12e3b2f8&scoped=true&"
import script from "./FeaturedQuotesCarousel.vue?vue&type=script&lang=js&"
export * from "./FeaturedQuotesCarousel.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedQuotesCarousel.vue?vue&type=style&index=0&id=12e3b2f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e3b2f8",
  null
  
)

export default component.exports